import { render, staticRenderFns } from "./GaoPaiYi.vue?vue&type=template&id=48ca777b&scoped=true"
import script from "./GaoPaiYi.vue?vue&type=script&lang=js"
export * from "./GaoPaiYi.vue?vue&type=script&lang=js"
import style0 from "./GaoPaiYi.vue?vue&type=style&index=0&id=48ca777b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ca777b",
  null
  
)

export default component.exports